module.exports = __webpack_public_path__ + "static/media/Weprologologin.d6f20ff7.svg";